import { Component } from "@angular/core";
import { OfferCardDirective } from "./offer-card";

@Component({
    selector: "deloitteai-offercard-owner",
    templateUrl: "./offer-card.owner.html",
    styleUrls: ["./offer-card.scss"]
})
export class DeloitteAiOfferCardOwnerComponent extends OfferCardDirective {
}
